export const DEFAULT_APP_ENVIRONMENT = 'development';
export const APP_NAME = process.env.NX_PUBLIC_APP_NAME ?? '';
export const PARENT_APPLICATION_ID =
  process.env.NX_PUBLIC_EXT_PARENT_APPLICATION_ID ?? '';
export const BASE_URL = process.env.NX_PUBLIC_HRMS_BACKEND_BASE_URL;
export const AUTH_BASE_URL = process.env.NX_PUBLIC_HRMS_AUTH_BACKEND_BASE_URL;
export const ZEPTO_DOMAIN = process.env.NX_PUBLIC_ZEPTO_DOMAIN ?? '';
export const APPLICATION_ID = process.env.NX_PUBLIC_EXT_APPLICATION_ID ?? '';
export const AUTH_URL = process.env.NX_PUBLIC_ZEPTO_AUTH_URL;
export const S3_ASSET_URL = process.env.NX_S3_ASSETS_URL ?? '';
export const X_API_KEY = process.env.NX_PUBLIC_API_KEY;
export const HRMS_WEB_APPLICATION_ID =
  process.env.NX_PUBLIC_WEB_APPLICATION_ID ?? '';
export const HRMS_MOBILE_APPLICATION_ID =
  process.env.NX_PUBLIC_MOBILE_APPLICATION_ID ?? '';
export const HRMS_TABLET_APPLICATION_ID =
  process.env.NX_PUBLIC_TABLET_APPLICATION_ID ?? '';
export const APP_ENVIRONMENT =
  process.env.NX_PUBLIC_NODE_ENV ?? DEFAULT_APP_ENVIRONMENT;
export const ZMAPS_STYLES_URL = process.env.NX_PUBLIC_ZMAP_STYLES_URL ?? '';
export const APP_VERSION = process.env['NX_RELEASE_VERSION'] ?? '';
export const AUTH_BACKEND_URL = process.env['NX_AUTH_BACKEND_URL'] ?? '';
export const TABLE_CELL_SIZE =
  window.innerWidth < 1440 ? 40 : window.innerWidth < 1600 ? 48 : 70;
export const ROWS_PER_PAGE = Math.floor(window.innerHeight / TABLE_CELL_SIZE);
export const REPORTING_MANAGER_MAX_SELECTION_COUNT = 3;
